import { Component } from '@angular/core';

@Component({
  selector: 'fake-items',
  templateUrl: 'fake-items.html'
})
export class FakeItemsComponent {

  constructor() {
    
  }

}


// WEBPACK FOOTER //
// ./src/components/fake-items/fake-items.ts